import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { uploadImage, uploadImageWithoutSize, updateGiftProduct, addProduct, getGiftById } from "../../shared/api/user";
import { useNavigate } from "react-router-dom";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { useParams } from "react-router-dom";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { CITY_NAMES } from '../../shared/constants/cities';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const sizeOptions = [
    'S',
    'M',
    'L',
    'XL',
    'XXL',
    '3/4-Y',
    '4/5-Y',
    '5/6-Y',
    '6/7-Y',
    '7/8-Y',
    '8/9-Y',
    '9/10-Y',
    '11/12-Y',
    '13/14-Y'
];

const convertFromPKR = (pkrAmount, ratePKR, rateTarget) => {
  return Number(((pkrAmount / ratePKR) * rateTarget).toFixed(2));
};


function getStyles(name, personName, theme) {
    return {
        fontWeight: personName.includes(name)
            ? theme.typography.fontWeightMedium
            : theme.typography.fontWeightRegular,
    };
}

const theme = createTheme();
export default function SignUp() {

    const [exchangeRates, setExchangeRates] = useState(null);
    const [File, setFile] = React.useState();
    const [uploadedImage, setUploadedImage] = useState(null);
    const [gift, setGift] = useState({});
    const navigate = useNavigate();
    const { id } = useParams();
    const [city, setCity] = useState('');
    const [type, setType] = useState('');
    const [message, setMessage] = useState('');
    const [Loading, setLoading] = useState(true);
    const [sizes, setSizes] = React.useState([]);
    const [sizeChartFile, setSizeChartFile] = useState(null);
    const [sizeChartPreview, setSizeChartPreview] = useState(null);
    const [pictureFiles, setPictureFiles] = useState([]);
    const [picturePreviews, setPicturePreviews] = useState([]);
    const [existingPictures, setExistingPictures] = useState([]);

    const [basePrice, setBasePrice] = useState(0);
const [localPercentage, setLocalPercentage] = useState(0);
const [intPercentage, setIntPercentage] = useState(0);
const [calculatedPrice, setCalculatedPrice] = useState(0);
const [internationalPrice, setInternationalPrice] = useState(0);


    const style = {
        "& .MuiOutlinedInput-root": {
            "&.Mui-focused fieldset": {
                borderColor: "#CB2704",
            },
        },
    };
    const theme = useTheme();
    const [personName, setPersonName] = React.useState([]);

    const handleChangeCity = (event) => {
        const {
            target: { value },
        } = event;
        setPersonName(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    // Handle sizes change
    const handleChangeSizes = (event) => {
        const {
            target: { value },
        } = event;
        setSizes(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    // Handle size chart upload
    const handleSizeChartFile = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setSizeChartFile(file);
            const reader = new FileReader();
            reader.onload = () => {
                setSizeChartPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // Handle multiple pictures upload
    const handlePictureFiles = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length > 0) {
            const newFiles = [...pictureFiles, ...files];
            // Limit to 6 pictures
            if (newFiles.length > 6) {
                setMessage('You can upload maximum 6 pictures');
                return;
            }
            setPictureFiles(newFiles);

            // Create previews
            const newPreviews = [];
            files.forEach(file => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    newPreviews.push(e.target.result);
                    if (newPreviews.length === files.length) {
                        setPicturePreviews([...picturePreviews, ...newPreviews]);
                    }
                };
                reader.readAsDataURL(file);
            });
        }
    };

    // Remove a picture
    const removePicture = (index) => {
        const newFiles = pictureFiles.filter((_, i) => i !== index);
        const newPreviews = picturePreviews.filter((_, i) => i !== index);
        setPictureFiles(newFiles);
        setPicturePreviews(newPreviews);
    };

    // Remove existing picture
    const removeExistingPicture = (index) => {
        const newExistingPictures = existingPictures.filter((_, i) => i !== index);
        setExistingPictures(newExistingPictures);
    };

    const init = async () => {
        let rows = await getGiftById(id);
        setGift(rows.data.Gift);
        console.log(rows.data.Gift);
        setCity(rows.data.Gift.city);
        setType(rows.data.Gift.type);
        setLoading(false);
        setPersonName(rows.data.Gift.city)
        setSizes(rows.data.Gift.sizes || []);
        setExistingPictures(rows.data.Gift.pictures || []);
        setUploadedImage(rows.data.Gift.picture || []);
        setBasePrice(rows.data.Gift.basePrice || 0);
        setLocalPercentage(rows.data.Gift.localPercentage || 0);
        setIntPercentage(rows.data.Gift.intPercentage || 0);
    };

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
  const fetchExchangeRates = async () => {
    try {
      const res = await fetch("https://open.er-api.com/v6/latest/USD");
      const data = await res.json();

      if (data?.result === "success") {
        setExchangeRates(data.rates);
      }
    } catch (err) {
      console.error("Exchange rate fetch failed", err);
    }
  };

  fetchExchangeRates();
}, []);

useEffect(() => {
    if (basePrice > 0) {
        const intPrice = basePrice + (basePrice * intPercentage / 100);
        setInternationalPrice(intPrice);
    } else {
        setInternationalPrice(0);
    }
}, [basePrice, intPercentage]);

useEffect(() => {
    if (exchangeRates && internationalPrice > 0 && gift && Object.keys(gift).length > 0) {
        const PKR_RATE = exchangeRates.PKR;
        
        // You need to update the form values
        // Since we're outside Formik, we need to use a ref or find another way
        // Let's create a function to update these values
    }
}, [internationalPrice, exchangeRates]);

useEffect(() => {
    if (basePrice > 0) {
        const calculated = basePrice + (basePrice * localPercentage / 100);
        setCalculatedPrice(calculated);
    } else {
        setCalculatedPrice(0);
    }
}, [basePrice, localPercentage]);

useEffect(() => {
    if (gift && Object.keys(gift).length > 0) {
        
    }
}, [calculatedPrice]);

useEffect(() => {
    if (exchangeRates && basePrice > 0 && intPercentage > 0 && gift && Object.keys(gift).length > 0) {
        const internationalPrice = basePrice + (basePrice * intPercentage / 100);
        const PKR_RATE = exchangeRates.PKR;
        
        // You can update these values in the form if needed
        console.log("International prices:", {
            priceUSD: convertFromPKR(internationalPrice, PKR_RATE, exchangeRates.USD),
            priceCAD: convertFromPKR(internationalPrice, PKR_RATE, exchangeRates.CAD),
            priceAED: convertFromPKR(internationalPrice, PKR_RATE, exchangeRates.AED),
            priceAUD: convertFromPKR(internationalPrice, PKR_RATE, exchangeRates.AUD),
            priceGBP: convertFromPKR(internationalPrice, PKR_RATE, exchangeRates.GBP),
            priceSAR: convertFromPKR(internationalPrice, PKR_RATE, exchangeRates.SAR),
        });
    }
}, [basePrice, intPercentage, exchangeRates]);


    const handleFile = async (event) => {
        console.log(event);
        setFile(event.target.files[0]);
        console.log(File);
        const reader = new FileReader();
        reader.onload = () => {
            setUploadedImage(reader.result);
        };
        if (event.target.files[0]) {
            reader.readAsDataURL(event.target.files[0]);
        }
    };

    const selectCity = (event) => {
        setCity(event.target.value);
    };

    const selectType = (event) => {
        setType(event.target.value);
    };

    if (!Loading) {
        return (
            <ThemeProvider theme={theme}>
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                        sx={{
                            marginTop: 8,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <Typography
                            sx={{ mt: 2, mb: 2, fontWeight: "600" }}
                            component="h1"
                            variant="h5"
                        >
                            Edit Product
                        </Typography>
                        <Box sx={{ mt: 3 }}>
                            <Grid container spacing={2}>
                                <Formik
                                    initialValues={{
                                        name: gift.name,
                                        description: gift.description,
                                        price: gift.price,
                                        basePrice: gift.basePrice || 0,           
                                        localPercentage: gift.localPercentage || 0,
                                        intPercentage: gift.intPercentage || 0,    

                                        priceUSD: gift.priceUSD,
                                        priceMYR: gift.priceMYR,
                                        priceEUR: gift.priceEUR,
                                        priceCAD: gift.priceCAD,
                                        priceAED: gift.priceAED,
                                        priceAUD: gift.priceAUD,
                                        priceGBP: gift.priceGBP,
                                        priceSAR: gift.priceSAR,
                                        
                                        priceOMR: gift.priceOMR,
                                        priceKWD: gift.priceKWD,
                                        priceBHD: gift.priceBHD,
                                        priceQAR: gift.priceQAR,

                                        vendor: gift.vendor,
                                        city: gift.city,
                                        picture: gift.picture,
                                        priceUSD: gift.priceUSD,
                                        priceCAD: gift.priceCAD,
                                        type: gift.type,
                                        sizes: gift.sizes || [],
                                        sizeChart: gift.sizeChart || '',
                                        pictures: gift.pictures || []

                                    }}
                                    onSubmit={(values, { setSubmitting }) => {
                                        setTimeout(async () => {
                                            if (File) {
                                                const formData = new FormData();
                                                formData.append("file", File);
                                                let res = await uploadImageWithoutSize(formData);
                                                values.picture = res.data.data.url;
                                            }
                                            
                                             // Upload size chart if changed
                                            if (sizeChartFile) {
                                                const formData = new FormData();
                                                formData.append("file", sizeChartFile);
                                                let res = await uploadImageWithoutSize(formData);
                                                values.sizeChart = res.data.data.url;
                                            }

                                            // Upload multiple pictures
                                            const pictureUrls = [...existingPictures];
                                            if (pictureFiles.length > 0) {
                                                for (const file of pictureFiles) {
                                                    const formData = new FormData();
                                                    formData.append("file", file);
                                                    let res = await uploadImageWithoutSize(formData);
                                                    pictureUrls.push(res.data.data.url);
                                                }
                                            }
                                            values.pictures = pictureUrls;
                                            values.basePrice = parseFloat(basePrice);           // Add this
                                            values.localPercentage = parseFloat(localPercentage); // Add this
                                            values.intPercentage = parseFloat(intPercentage);     // Add this

                                            values.price = calculatedPrice > 0 ? calculatedPrice : parseFloat(values.price);

                                            values.city = personName;
                                            values.sizes = sizes;

                                            // let priceUSD = ((values.price / 275) * 1.8).toFixed(2);
                                            // let priceCAD = ((values.price / 200) * 1.1).toFixed(2);
                                            // values.priceUSD = Number(priceUSD);
                                            // values.priceCAD = Number(priceCAD);

                                            if (!exchangeRates) {
                                            setMessage("Exchange rates not loaded yet. Please try again.");
                                            setSubmitting(false);
                                            return;
                                            }

                                             

                                // Use international price for currency conversions
                                            const internationalPriceForConversion = basePrice + (basePrice * intPercentage / 100);
                                            const PKR_RATE = exchangeRates.PKR;

                                            values.priceUSD = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.USD);
                                            values.priceMYR = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.MYR);
                                            values.priceEUR = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.EUR);
                                            values.priceCAD = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.CAD);
                                            values.priceAED = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.AED);
                                            values.priceAUD = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.AUD);
                                            values.priceGBP = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.GBP);
                                            values.priceSAR = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.SAR);

                                            values.priceOMR = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.OMR);
                                            values.priceKWD = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.KWD);
                                            values.priceBHD = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.BHD);
                                            values.priceQAR = convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.QAR);




                                            values.type = type;
                                            if (!type && !personName && !values.price && !values.picture) {
                                                setMessage('All fields are required!');
                                                setSubmitting(false);
                                            } else {
                                                setMessage('');
                                                let prod = await updateGiftProduct(id, values);
                                                setSubmitting(false);
                                                navigate("/gifts");
                                            }
                                        }, 400);
                                    }}
                                >
                                    {({ handleSubmit, handleChange, isSubmitting, values, setFieldValue }) => {
        // Real-time currency updates based on international percentage
        React.useEffect(() => {
            if (exchangeRates && basePrice > 0) {
                const internationalPriceForConversion = basePrice + (basePrice * intPercentage / 100);
                const PKR_RATE = exchangeRates.PKR;
                
                setFieldValue('priceUSD', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.USD));
                setFieldValue('priceMYR', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.MYR));
                setFieldValue('priceEUR', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.EUR));
                setFieldValue('priceCAD', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.CAD));
                setFieldValue('priceAED', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.AED));
                setFieldValue('priceAUD', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.AUD));
                setFieldValue('priceGBP', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.GBP));
                setFieldValue('priceSAR', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.SAR));

                 setFieldValue('priceOMR', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.OMR));
                setFieldValue('priceKWD', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.KWD));
                setFieldValue('priceBHD', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.BHD));
                setFieldValue('priceQAR', convertFromPKR(internationalPriceForConversion, PKR_RATE, exchangeRates.QAR));
            }
        }, [basePrice, intPercentage, exchangeRates, setFieldValue]);

        return (
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                handleSubmit();
                                            }}
                                        >
                                            <Grid mb={3} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="name"
                                                    label="Product Name"
                                                    name="name"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    value={values.name}
                                                />
                                            </Grid>
                                            <Grid mb={3} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="description"
                                                    label="Description"
                                                    name="description"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    value={values.description}
                                                />
                                            </Grid>

                                            <Grid mb={2} item xs={12}>
    <TextField
        sx={style}
        InputLabelProps={{
            sx: {
                [`&.${inputLabelClasses.shrink}`]: {
                    color: "#CB2704",
                },
            },
        }}
        fullWidth
        id="basePrice"
        label="Base Price"
        name="basePrice"
        type="number"
        autoComplete="text"
        value={basePrice}
        onChange={(e) => setBasePrice(parseFloat(e.target.value) || 0)}
    />
</Grid>

<Grid mb={2} item xs={12}>
    <TextField
        sx={style}
        InputLabelProps={{
            sx: {
                [`&.${inputLabelClasses.shrink}`]: {
                    color: "#CB2704",
                },
            },
        }}
        fullWidth
        id="localPercentage"
        label="Local Percentage (%)"
        name="localPercentage"
        type="number"
        autoComplete="text"
        value={localPercentage}
        onChange={(e) => setLocalPercentage(parseFloat(e.target.value) || 0)}
    />
</Grid>

<Grid mb={2} item xs={12}>
    <TextField
        sx={style}
        InputLabelProps={{
            sx: {
                [`&.${inputLabelClasses.shrink}`]: {
                    color: "#CB2704",
                },
            },
        }}
        fullWidth
        id="intPercentage"
        label="International Percentage (%)"
        name="intPercentage"
        type="number"
        autoComplete="text"
        value={intPercentage}
        onChange={(e) => setIntPercentage(parseFloat(e.target.value) || 0)}
    />
</Grid>

                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="price"
                                                    label="Price"
                                                    name="price"
                                                    value={calculatedPrice || values.price}

                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}

                                                />
                                            </Grid>

                                                <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceUSD"
                                                    label="Price USD"
                                                    name="priceUSD"
                                                    value={values.priceUSD}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceMYR"
                                                    label="Price MYR"
                                                    name="priceMYR"
                                                    value={values.priceMYR}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceEUR"
                                                    label="Price EUR"
                                                    name="priceEUR"
                                                    value={values.priceEUR}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceCAD"
                                                    label="Price CAD"
                                                    name="priceCAD"
                                                    value={values.priceCAD}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceAED"
                                                    label="Price AED"
                                                    name="priceAED"
                                                    value={values.priceAED}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceAUD"
                                                    label="Price AUD"
                                                    name="priceAUD"
                                                    value={values.priceAUD}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceGBP"
                                                    label="Price GBP"
                                                    name="priceGBP"
                                                    value={values.priceGBP}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceSAR"
                                                    label="Price SAR"
                                                    name="priceSAR"
                                                    value={values.priceSAR}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceOMR"
                                                    label="Price OMR"
                                                    name="priceOMR"
                                                    value={values.priceOMR}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceKWD"
                                                    label="Price KWD"
                                                    name="priceKWD"
                                                    value={values.priceKWD}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceBHD"
                                                    label="Price BHD"
                                                    name="priceBHD"
                                                    value={values.priceBHD}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="priceQAR"
                                                    label="Price QAR"
                                                    name="priceQAR"
                                                    value={values.priceQAR}
                                                    type="number"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                />
                                            </Grid>


                                            <Grid mb={2} item xs={12}>
                                                <TextField
                                                    sx={style}
                                                    InputLabelProps={{
                                                        sx: {
                                                            [`&.${inputLabelClasses.shrink}`]: {
                                                                color: "#CB2704",
                                                            },
                                                        },
                                                    }}
                                                    fullWidth
                                                    id="vendor"
                                                    label="Vendor"
                                                    name="vendor"
                                                    value={values.vendor}
                                                    type="text"
                                                    autoComplete="text"
                                                    onChange={handleChange}
                                                />
                                            </Grid>
                                            <Box mb={2} sx={{ minWidth: 120 }}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">City</InputLabel>
                                                    {/* <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={city}
                                                        label="City"
                                                        onChange={selectCity}
                                                    >
                                                        <MenuItem value={"LAHORE"}>Lahore</MenuItem>
                                                        <MenuItem value={"ISLAMABAD"}>Islamabad</MenuItem>
                                                        <MenuItem value={"KARACHI"}>Karachi</MenuItem>
                                                        <MenuItem value={"RAWALPINDI"}>Rawalpindi</MenuItem>
                                                    </Select> */}
                                                    <Select
                                                        labelId="demo-multiple-name-label"
                                                        id="demo-multiple-name"
                                                        multiple
                                                        value={personName}
                                                        onChange={handleChangeCity}
                                                        input={<OutlinedInput label="Name" />}
                                                        MenuProps={MenuProps}
                                                    >
                                                        {CITY_NAMES.map((name) => (
                                                            <MenuItem
                                                                key={name}
                                                                value={name}
                                                                style={getStyles(name, personName, theme)}
                                                            >
                                                                {name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>

                                            <Box sx={{ minWidth: 120 }}>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Type</InputLabel>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        value={type}
                                                        label="City"
                                                        onChange={selectType}
                                                    >
                                                        <MenuItem value={"FLOWERS"}>FLOWERS</MenuItem>
                                                        <MenuItem value={"CHOCOLATES"}>CHOCOLATES</MenuItem>
                                                        <MenuItem value={"SWEETS"}>SWEETS</MenuItem>
                                                        <MenuItem value={"CHOCOLATES_FLOWERS"}>CHOCOLATES_FLOWERS</MenuItem>
                                                        <MenuItem value={"BASKET_FLOWERS"}>BASKET_FLOWERS</MenuItem>
                                                        <MenuItem value={"CHOCOLATES_BOUQUET"}>CHOCOLATES_BOUQUET</MenuItem>
                                                        <MenuItem value={"CAKE_FLOWERS"}>CAKE_FLOWERS</MenuItem>
                                                        <MenuItem value={"BASKET"}>BASKET</MenuItem>
                                                        <MenuItem value={"CAKES"}>CAKES</MenuItem>
                                                        <MenuItem value={"PERFUMES"}>PERFUMES</MenuItem>
                                                        <MenuItem value={"WALLETS"}>WALLETS</MenuItem>
                                                        <MenuItem value={"WOMEN_CROSSBODY_BAGS"}>WOMEN_CROSSBODY_BAGS</MenuItem>
                                                        <MenuItem value={"WATCHES"}>WATCHES</MenuItem>
                                                        <MenuItem value={"CLOTHING"}>CLOTHING</MenuItem>
                                                        <MenuItem value={"MEN_CLOTHING"}>MEN CLOTHING</MenuItem>
                                                        <MenuItem value={"WOMEN_CLOTHING"}>WOMEN CLOTHING</MenuItem>
                                                        <MenuItem value={"KIDS_CLOTHING"}>KIDS CLOTHING</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Box>

                                            <div style={{ textAlign: "center", marginTop: "20px" }}>
                                                {uploadedImage && (
                                                    <img
                                                        src={uploadedImage}
                                                        alt="Uploaded"
                                                        style={{
                                                            maxWidth: "100%",
                                                            maxHeight: "200px",
                                                            borderRadius: "10px",
                                                        }}
                                                    />
                                                )}
                                            </div>

                                            <Button
                                                variant="contained"
                                                component="label"
                                                fullWidth
                                                sx={{
                                                    mt: 3,
                                                    mb: 1,
                                                    background: '#CB2704', "&:hover": { background: "red" }
                                                }}
                                            >
                                                Upload Image
                                                <input type="file" onChange={handleFile} hidden />
                                            </Button>

                                            {message && <div style={{ color: '#CB2704' }}>{message}</div>}

  {/* Sizes Selection - NEW */}
                                                <Grid item xs={12}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="sizes-label">Sizes</InputLabel>
                                                        <Select
                                                            labelId="sizes-label"
                                                            id="sizes-select"
                                                            multiple
                                                            value={sizes}
                                                            onChange={handleChangeSizes}
                                                            input={<OutlinedInput label="Sizes" />}
                                                            MenuProps={MenuProps}
                                                            renderValue={(selected) => (
                                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                    {selected.map((value) => (
                                                                        <Chip key={value} label={value} size="small" />
                                                                    ))}
                                                                </Box>
                                                            )}
                                                        >
                                                            {sizeOptions.map((size) => (
                                                                <MenuItem
                                                                    key={size}
                                                                    value={size}
                                                                    style={getStyles(size, sizes, theme)}
                                                                >
                                                                    {size}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                  {/* Size Chart Image - NEW */}
                                                <Grid item xs={12}>
                                                    <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                                                        Size Chart Image
                                                    </Typography>
                                                    <div style={{ textAlign: "center", marginBottom: "10px" }}>
                                                        {(sizeChartPreview || values.sizeChart) && (
                                                            <img
                                                                src={sizeChartPreview || values.sizeChart}
                                                                alt="Size Chart"
                                                                style={{
                                                                    maxWidth: "100%",
                                                                    maxHeight: "200px",
                                                                    borderRadius: "10px",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                    <Button
                                                        variant="contained"
                                                        component="label"
                                                        fullWidth
                                                        sx={{
                                                            background: '#CB2704', 
                                                            "&:hover": { background: "red" }
                                                        }}
                                                    >
                                                        Upload Size Chart
                                                        <input type="file" onChange={handleSizeChartFile} hidden />
                                                    </Button>
                                                </Grid>

                                                {/* Multiple Pictures - NEW */}
                                                <Grid item xs={12}>
                                                    <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                                                        Additional Pictures (Max 6)
                                                    </Typography>
                                                    
                                                    {/* Existing Pictures */}
                                                    {existingPictures.length > 0 && (
                                                        <>
                                                            <Typography variant="body2" color="textSecondary" gutterBottom>
                                                                Existing Pictures:
                                                            </Typography>
                                                            <ImageList sx={{ width: '100%', height: 'auto' }} cols={3} rowHeight={120}>
                                                                {existingPictures.map((pic, index) => (
                                                                    <ImageListItem key={index} sx={{ position: 'relative' }}>
                                                                        <img
                                                                            src={pic}
                                                                            alt={`Product ${index + 1}`}
                                                                            style={{ height: 120, width: '100%', objectFit: 'cover' }}
                                                                        />
                                                                        <IconButton
                                                                            size="small"
                                                                            sx={{
                                                                                position: 'absolute',
                                                                                top: 5,
                                                                                right: 5,
                                                                                backgroundColor: 'rgba(255,255,255,0.8)',
                                                                                '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                                                                            }}
                                                                            onClick={() => removeExistingPicture(index)}
                                                                        >
                                                                            <CloseIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </ImageListItem>
                                                                ))}
                                                            </ImageList>
                                                        </>
                                                    )}

                                                    {/* New Picture Previews */}
                                                    {picturePreviews.length > 0 && (
                                                        <>
                                                            <Typography variant="body2" color="textSecondary" gutterBottom sx={{ mt: 2 }}>
                                                                New Pictures:
                                                            </Typography>
                                                            <ImageList sx={{ width: '100%', height: 'auto' }} cols={3} rowHeight={120}>
                                                                {picturePreviews.map((preview, index) => (
                                                                    <ImageListItem key={index} sx={{ position: 'relative' }}>
                                                                        <img
                                                                            src={preview}
                                                                            alt={`New ${index + 1}`}
                                                                            style={{ height: 120, width: '100%', objectFit: 'cover' }}
                                                                        />
                                                                        <IconButton
                                                                            size="small"
                                                                            sx={{
                                                                                position: 'absolute',
                                                                                top: 5,
                                                                                right: 5,
                                                                                backgroundColor: 'rgba(255,255,255,0.8)',
                                                                                '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' }
                                                                            }}
                                                                            onClick={() => removePicture(index)}
                                                                        >
                                                                            <CloseIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </ImageListItem>
                                                                ))}
                                                            </ImageList>
                                                        </>
                                                    )}

                                                    {existingPictures.length + pictureFiles.length < 6 && (
                                                        <Button
                                                            variant="contained"
                                                            component="label"
                                                            fullWidth
                                                            sx={{
                                                                mt: 2,
                                                                background: '#CB2704', 
                                                                "&:hover": { background: "red" }
                                                            }}
                                                        >
                                                            Upload Additional Pictures
                                                            <input 
                                                                type="file" 
                                                                onChange={handlePictureFiles} 
                                                                hidden 
                                                                multiple 
                                                                accept="image/*"
                                                            />
                                                        </Button>
                                                    )}
                                                </Grid>

                                                {message && (
                                                    <Grid item xs={12}>
                                                        <div style={{ color: '#CB2704', textAlign: 'center' }}>{message}</div>
                                                    </Grid>
                                                )}

                                            <Button
                                                type="submit"
                                                disabled={isSubmitting}
                                                fullWidth
                                                variant="contained"
                                                sx={{
                                                    mt: 2,
                                                    mb: 2,
                                                    background: '#CB2704', "&:hover": { background: "red" }
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </form>
                                         );
                                    }}
                                </Formik>
                            </Grid>
                        </Box>
                    </Box>
                </Container>
            </ThemeProvider>
        );
    }
}
